import { createSelector } from 'reselect';

import type { DeviceListFilterCounts, DeviceListItem, DeviceListSummary } from 'src/service/api/deviceList';

export const getDeviceListState = (state) =>
  state.deviceList;

export const getDeviceListItems = createSelector(
  [getDeviceListState],
  (deviceList): DeviceListItem[] => deviceList.get('items')
);

export const getDeviceListLoading = createSelector(
  [getDeviceListState],
  (deviceList): boolean => deviceList.get('loading')
);

export const getDeviceListHasMore = createSelector(
  [getDeviceListState],
  (deviceList): boolean => deviceList.get('hasMore')
);

export const getDeviceListDeviceCount = createSelector(
  [getDeviceListState],
  (deviceList): number | null => deviceList.get('deviceCount')
);

export const getDeviceListSummary = createSelector(
  [getDeviceListState],
  (deviceList): DeviceListSummary | null => deviceList.get('summary')
);

export const getDeviceListError = createSelector(
  [getDeviceListState],
  (deviceList) => deviceList.get('error')
);

export const getDeviceListFilterCounts = createSelector(
  [getDeviceListState],
  (deviceList): DeviceListFilterCounts | null => deviceList.get('filterCounts')
);
